<template>
  <v-layout row wrap>
    <v-flex xs5 text-xs-center class="">
      <square-combook-binding-frame
        :cover-thumbnail-url="combookBinding.coverThumbnailUrl"
      ></square-combook-binding-frame>
    </v-flex>

    <v-flex pl-2 xs7 text-xs-left>
      <table class="table-vertical caption">
        <tr>
          <th>園・施設名:</th>
          <td class="text-xs-right">{{ organizationName }}</td>
        </tr>
        <tr>
          <th>名前:</th>
          <td class="text-xs-right">{{ combookBinding.kidFullName }} さん</td>
        </tr>
        <tr>
          <th>期間:</th>
          <td class="text-xs-right">{{ targetPeriodText }}</td>
        </tr>
        <tr>
          <th>表紙:</th>
          <td class="text-xs-right">
            {{ combookBinding.coverDesignTypeText }}
          </td>
        </tr>
        <tr>
          <th>表紙の印字:</th>
          <td class="text-xs-right">
            {{ combookBinding.coverOrganizationName }} /
            {{ combookBinding.coverKidName }}
          </td>
        </tr>
      </table>
    </v-flex>
  </v-layout>
</template>

<script>
import OrderDetail from "../../../models/OrderDetail";

import SquareCombookBindingFrame from "../../../components/SquareCombookBindingFrame";

export default {
  components: {
    "square-combook-binding-frame": SquareCombookBindingFrame
  },
  props: {
    detail: {
      type: OrderDetail,
      required: true
    },
    organizationName: {
      type: String,
      required: true
    }
  },
  computed: {
    combookBinding() {
      return this.detail.combookBinding;
    },
    targetPeriodText() {
      let text = `${this.combookBinding.year}年 ${this.combookBinding.startMonth}月〜${this.combookBinding.endMonth}月`;
      if (!this.combookBinding.isIncludePhotos) {
        text += "（写真なし）";
      }
      return text;
    }
  }
};
</script>
